var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWritevector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50488 7.94872L7.55616 10C8.10317 8.35897 10.0587 4.46154 13.5049 2",
    stroke: "#252525",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4887 4.63306C13.8743 4.36817 14.4064 4.46424 14.6262 4.87727C15.324 6.18891 15.6196 7.68473 15.4647 9.17513C15.2805 10.9477 14.4711 12.5967 13.1816 13.8268C11.8921 15.0569 10.2068 15.7876 8.42752 15.888C6.64825 15.9884 4.89137 15.452 3.47165 14.3748C2.05193 13.2977 1.06215 11.7502 0.679665 10.0096C0.297176 8.26905 0.546969 6.44916 1.38429 4.87602C2.22161 3.30289 3.59173 2.0793 5.24917 1.42451C6.64279 0.873948 8.16296 0.755761 9.61408 1.07455C10.071 1.17494 10.3069 1.66152 10.1556 2.10424C10.0044 2.54696 9.52302 2.77661 9.06301 2.69134C7.99689 2.49372 6.89059 2.59768 5.87167 3.00022C4.58864 3.5071 3.52802 4.45428 2.87985 5.67205C2.23167 6.88982 2.03831 8.29861 2.33439 9.64599C2.63048 10.9934 3.39667 12.1913 4.49568 13.0251C5.5947 13.859 6.95471 14.2742 8.33205 14.1965C9.70938 14.1187 11.014 13.5531 12.0122 12.6009C13.0104 11.6487 13.637 10.3722 13.7796 9.00001C13.8928 7.91034 13.695 6.81692 13.2175 5.84341C13.0115 5.42337 13.103 4.89795 13.4887 4.63306Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritevector);
export default __webpack_public_path__ + "static/media/writevector.46680973d11d3410396caad1ff142e96.svg";
export { ForwardRef as ReactComponent };